import { ref, watch } from 'vue';
import { clientApi } from '@phoenix/clientApi';
import { get } from 'lodash-es';

export const useTotalPrice = (props, getOptionItemParam) => {
  const totalPrice = ref(0.0);
  const fromTotalPrice = ref(false);
  const formattedTotalPrice = ref('');

  const calculateTotalPrice = (configuration) => {
    let total = 0;
    let fromPrice = false;

    if (configuration.engraving !== null) {
      total += getOptionItemParam('engravings', configuration.engraving, 'price', 0);
      if (getOptionItemParam('engravings', configuration.engraving, 'fromPrice', false)) {
        fromPrice = true;
      }
    }

    for (const [key, value] of Object.entries(configuration.options)) {
      if (value !== null) {
        total += getOptionItemParam(props.matchConfigurationIds[key], value, 'price', 0, true);
        if (getOptionItemParam(props.matchConfigurationIds[key], value, 'fromPrice', false, true)) {
          fromPrice = true;
        }
      }
    }

    totalPrice.value = total;
    fromTotalPrice.value = fromPrice;
  };

  watch(totalPrice, async (value) => {
    try {
      const { data } = await clientApi.post(window.route('api.engravingTool.formatPrice'), {
        price: value,
        fromPrice: fromTotalPrice.value,
      });

      formattedTotalPrice.value = data.data.price;
    } catch (error) {
      window.Phoenix.sentry.captureException(error);
      window.Phoenix.toaster.notify({
        type: 'danger',
        text: get(error, 'response.data.message', error.message),
      });
    }
  });

  return {
    formattedTotalPrice,
    calculateTotalPrice,
  };
};
